
import { Icon } from '@iconify/react'
import "./InfoCard.scss"
export default function InfoCard({divClassName,iconClassName, icon, label, text, textClassName}:any) {
  return (
    <div className={`flexible--row infoCardContainer ${divClassName}`}>
        <div className={"icon "+iconClassName}>
            <Icon icon={icon}/>
        </div>
        <div className='flexible--column margin-left'>
            <p className='label'>{label}</p>
            <h3 className={textClassName}>{text}</h3>
        </div>
    </div>
  )
}

